import { useMemo } from 'react';
export const useVortexIntializationOptions = _ref => {
  let {
    view
  } = _ref;
  return useMemo(() => {
    var _a, _b;
    return (_b = (_a = view.vortex.stage.content.animationSettings) === null || _a === void 0 ? void 0 : _a.initialization) === null || _b === void 0 ? void 0 : _b.reduce((previous, animation) => {
      if (animation.type === 'camera') {
        previous = Object.assign(Object.assign({}, previous), {
          cameraOrientation: {
            azimuthAngle: animation.view.rotation.azimuth,
            polarAngle: animation.view.rotation.polar
          }
        });
      }
      if (animation.type === 'swivel') {
        previous = Object.assign(Object.assign({}, previous), {
          swivel: {
            enabled: true,
            damping: animation.damping,
            range: animation.range
          }
        });
      }
      return previous;
    }, {
      scaleToInitialState: true
    });
  }, [view]);
};